import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import "./CountDownSection.css";

const CountDownSection = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date("2025-09-26T10:00:00").getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="countdown-section">
      <div className="countdown-particles"></div>
      <div className="countdown-overlay"></div>
      <Container className="position-relative">
        <div className="countdown-content">
          <h2 className="countdown-title">Don't Miss It!</h2>
          <div className="countdown-subtitle">Conference will start in</div>
          
          <div className="countdown-timer-wrapper">
            <div className="countdown-timer">
              <div className="countdown-item">
                <div className="countdown-card">
                  <div className="countdown-value">{String(timeLeft.days).padStart(2, '0')}</div>
                  <div className="countdown-label">Days</div>
                </div>
              </div>
              
              <div className="countdown-item">
                <div className="countdown-card">
                  <div className="countdown-value">{String(timeLeft.hours).padStart(2, '0')}</div>
                  <div className="countdown-label">Hours</div>
                </div>
              </div>
              
              <div className="countdown-item">
                <div className="countdown-card">
                  <div className="countdown-value">{String(timeLeft.minutes).padStart(2, '0')}</div>
                  <div className="countdown-label">Minutes</div>
                </div>
              </div>
              
              <div className="countdown-item">
                <div className="countdown-card">
                  <div className="countdown-value">{String(timeLeft.seconds).padStart(2, '0')}</div>
                  <div className="countdown-label">Seconds</div>
                </div>
              </div>
            </div>
          </div>
          
          {/* <button className="register-button">Register Now</button> */}
        </div>
      </Container>
    </section>
  );
};

export default CountDownSection;